import { Star } from "lucide-react";

export function StarRating({ value = 0, size = "h-4 w-4", className = "" }) {
  return (
    <div className={`flex items-center gap-0.5 ${className}`} data-testid="star-display">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`${size} ${i <= Math.round(value) ? "fill-gold text-gold" : "text-slate-600"}`} />
      ))}
    </div>
  );
}

export function StarInput({ value, onChange, size = "h-9 w-9" }) {
  return (
    <div className="flex items-center gap-1.5" data-testid="star-input">
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          data-testid={`star-${i}`}
          onClick={() => onChange(i)}
          className="transition-transform duration-150 hover:scale-110 focus:outline-none"
          aria-label={`${i} star${i > 1 ? "s" : ""}`}
        >
          <Star className={`${size} ${i <= value ? "fill-gold text-gold" : "text-slate-500"}`} />
        </button>
      ))}
    </div>
  );
}
